<div class="report-wrapper">
    <h3 class="text"> {{'UNAUTHORIZED' | translate}}
    </h3>

</div>